import { GET_TAGESDATEN_BY_STANDORTID_AND_ZEITRAUM } from '@/domain/termine/hooks/graphql/queries';
import { TerminKalender } from '@/domain/termine/shared/types/TerminKalender';
import { GetTagesDatenQuery } from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';
import { useTranslation } from 'react-i18next';

const OHNE_KALENDER_ID = 'NO_KALENDER';

function defaultOhneKalender(
  kalender: TerminKalender[],
  t: (key: string) => string,
) {
  if (!kalender.some((k) => k.id === OHNE_KALENDER_ID)) {
    return [
      ...kalender,
      new TerminKalender({
        id: OHNE_KALENDER_ID,
        name: t('domain.termine.ohneCalendar'),
      }),
    ];
  }
  return kalender;
}

export function useTerminKalender(
  standortIds: string[],
  zeitraum: { von: string; bis: string },
): { kalender: TerminKalender[]; error: Error | null } {
  const { t } = useTranslation();
  const { data, error } = useSuspenseQuery<
    GetTagesDatenQuery,
    { standortIds: string[]; zeitraum: { von: string; bis: string } }
  >(GET_TAGESDATEN_BY_STANDORTID_AND_ZEITRAUM, {
    variables: { standortIds, zeitraum },
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  if (error || !data) {
    return { kalender: [], error: error ?? new Error('No data') };
  }

  const kalenderResult = data?.termine_termineKalenderByStandortIdAndZeitraum;
  if (!kalenderResult || kalenderResult.length === 0) {
    return { kalender: [], error: null };
  }

  const kalender = kalenderResult.map((k) => new TerminKalender(k));
  return { kalender: defaultOhneKalender(kalender, t), error };
}
